<template>
    <form
        :action="url"
        @submit.prevent="resendNotification"
    >
        <loading-button :loading="form.processing" class="w-full btn btn-green">Resend Verification Email</loading-button>
    </form>
</template>

<script>
import Form from '@/functions/Form'
import LoadingButton from '@/components/shared/LoadingButton'

export default {
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            form: Form()
        }
    },
    methods: {
        resendNotification() {
            this.form.post(this.url, {
                onSuccess: ({ notification }) => this.$store.commit('setNotification', notification)
            })
        }
    },
    components: {
        LoadingButton
    }
}
</script>
